module.exports = __webpack_public_path__ + "img/mobile_parked.91210445.svg";